import styled from "styled-components";

import { Box, Text } from "@similarweb/ui-components/foundations";

import { BodyWrapper } from "app/components/React/WidgetContainer/styledComponents";

export const TableWrapper = styled(Box)`
    & > div {
        box-shadow: none;
        height: 100%;
    }

    & ${BodyWrapper} {
        overflow-y: auto;
    }
`;

export const TopicName = styled(Text)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
